"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SetDragImage_1 = require("Dashboard/SetDragImage");
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var BASE_CLASS_NAME = "draggable-image-card";
var DraggableImageCard = (function (_super) {
    __extends(DraggableImageCard, _super);
    function DraggableImageCard() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.imageRef = (0, react_1.createRef)();
        _this.hasImageLoaded = false;
        _this.handleImageLoaded = function () {
            var image = _this.props.image;
            var img = new window.Image();
            img.onload = _this.setHasImageLoaded;
            img.src = image.thumbnailUrl;
        };
        _this.setHasImageLoaded = function () {
            _this.hasImageLoaded = true;
        };
        _this.handleDragStart = function (event) {
            var onDragStart = _this.props.onDragStart;
            var dragImageElement = _this.imageRef.current.cloneNode(true);
            dragImageElement.style.width = "86px";
            dragImageElement.style.height = "64px";
            (0, SetDragImage_1.setDragImage)(event, dragImageElement);
            onDragStart(event);
        };
        return _this;
    }
    DraggableImageCard.prototype.componentDidMount = function () {
        this.handleImageLoaded();
    };
    DraggableImageCard.prototype.render = function () {
        var _a;
        var _b = this.props, image = _b.image, onClick = _b.onClick, onDragEnd = _b.onDragEnd;
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME, draggable: true, onDragStart: this.handleDragStart, onDragEnd: onDragEnd },
            react_1.default.createElement(kaleidoscope_1.ButtonCard, { isDraggable: true, className: "".concat(BASE_CLASS_NAME, "__button"), onClick: onClick },
                react_1.default.createElement("div", { className: (0, classnames_1.default)((_a = {},
                        _a["".concat(BASE_CLASS_NAME, "__image_loaded")] = this.hasImageLoaded,
                        _a["".concat(BASE_CLASS_NAME, "__image")] = true,
                        _a)), style: { backgroundImage: this.hasImageLoaded ? "url(".concat(image.thumbnailUrl, ")") : "" }, ref: this.imageRef }, image.name && react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__name") }, image.name)))));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], DraggableImageCard.prototype, "hasImageLoaded", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], DraggableImageCard.prototype, "handleImageLoaded", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], DraggableImageCard.prototype, "setHasImageLoaded", void 0);
    DraggableImageCard = __decorate([
        mobx_react_1.observer
    ], DraggableImageCard);
    return DraggableImageCard;
}(react_1.default.Component));
exports.default = DraggableImageCard;
